module.exports = __webpack_public_path__ + "static/media/services-bg-1.579981e1.png";